import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const traceTerminalsAdapter = getAdapter({ idFieldName: 'value' });

const traceTerminalsSlice = createSlice({
  name: 'traceTerminals',
  initialState: traceTerminalsAdapter.getInitialState(),
  reducers: {
    setTraceTerminals: (state, { payload: { traceTerminals } }) => {
      traceTerminalsAdapter.setAll(state, traceTerminals);
    }
  }
});

const selectors = traceTerminalsAdapter.getSelectors(({ traceTerminals }) => traceTerminals);

export const getTraceTerminals = (state) => selectors.selectAll(state);

export const { setTraceTerminals } = traceTerminalsSlice.actions;

export default traceTerminalsSlice.reducer;
